import { GlobalState } from '../../actions';

export const hsdSelector = (state: GlobalState) => state.hsd;

export const hsdEntitySelector = (state: GlobalState) => hsdSelector(state).hsd;
export const hsdUgIdSelector = (state: GlobalState) => hsdSelector(state).ugId;
export const hsdUgNameSelector = (state: GlobalState) => hsdSelector(state).ugName;